/**
 * Язык используемый на странице
 */
export default (window.app && window.app.locale) || 'ru-RU'
